import {Injectable} from "@angular/core";
import {Apollo} from "apollo-angular";
import {CDFGqlModel, CDFInputGqlModel, CDFInputResultGqlModel} from "./cdf.gql-model";
import {CDFPreviewGqlModel} from "./cdf-preview.gql-model";

@Injectable()
export class CdfImportService {
  constructor(private apollo: Apollo) {}

  getCdf(projectId: string, siteId: string): Promise<CDFGqlModel> {
    const query = CDFGqlModel.query;
    const variables = CDFGqlModel.variables(projectId, siteId);

    return this.apollo.query({query, variables, fetchPolicy: "no-cache"})
      .pipe(CDFGqlModel.mapper)
      .toPromise();
  }

  getCdfPreview(dealId: string): Promise<CDFPreviewGqlModel> {
    const query = CDFPreviewGqlModel.query;
    const variables = CDFPreviewGqlModel.variables(dealId);

    return this.apollo.query({query, variables}) // allow cache
      .pipe(CDFPreviewGqlModel.mapper)
      .toPromise();
  }

  importCdf(cdf: CDFGqlModel, projectId: string, removeAssets: boolean): Promise<CDFInputResultGqlModel> {
    const model = new CDFInputGqlModel({cdf, projectId, removeAssets});

    return this.apollo.mutate({mutation: model.mutation, variables: model.variables, fetchPolicy: "no-cache"})
      .pipe(CDFInputGqlModel.mapper)
      .toPromise();
  }
}
